import { RestOptions } from '@csp/csp-common-model';
import { Page } from '@csp/dmdp-api-common-dto';
import {
  BioSamplingContainerQueryV1,
  BioSamplingSupplyContainersV1,
  BioSamplingSupplyKitInfoQueryInV1,
  BioSamplingSupplyKitInfosOutV1,
} from '@csp/dmdp-api-hbs-supply-dto';
import { biosamplingsupplyUrl } from '../../dmdp-config/dmdpConfig';

const url = (): string => `${biosamplingsupplyUrl()}/bio-sampling-supply/v1/containers`;

const queryContainers = async (
  { axios, signal }: RestOptions,
  queryV1: BioSamplingContainerQueryV1,
  page?: Page,
): Promise<BioSamplingSupplyContainersV1> => {
  const resp = await axios.post(`${url()}:query`, queryV1, {
    params: page,
    signal,
  });
  return resp.data;
};

const queryKitInfos = async (
  { axios, signal }: RestOptions,
  queryV1: BioSamplingSupplyKitInfoQueryInV1,
): Promise<BioSamplingSupplyKitInfosOutV1> => {
  const resp = await axios.post(`${url()}/kit-info:outcome`, queryV1, {
    signal,
  });
  return resp.data;
};

export const BioSamplingContainerRestServiceV1 = {
  queryContainers,
  queryKitInfos,
};
